<script setup>

    import { computed } from 'vue'

    const props = defineProps({
        color: {
            type: String,
            default: 'green' // Possible values: 'green', 'blue', 'red'
        }
    })

    const colorClasses = computed(() => {
        switch (props.color) {
            case 'blue':
                return 'bg-lifeworx-blue-600/10 text-lifeworx-blue-600';
            case 'red':
                return 'bg-lifeworx-red-500/10 text-lifeworx-red-500';
            case 'orange':
                return 'bg-lifeworx-orange-500/10 text-lifeworx-orange-500';
            case 'yellow':
                return 'bg-lifeworx-yellow-600/10 text-lifeworx-yellow-600';
            case 'purple':
                return 'bg-lifeworx-purple-500/10 text-lifeworx-purple-500';
            case 'green':
                return 'bg-lifeworx-green-500/10 text-lifeworx-green-500';
        }
    })

</script>

<template>
    <div
        :class="[
            'flex flex-initial justify-center items-center font-semibold rounded-full px-2 capitalize p-1 h-fit w-fit',
            colorClasses
        ]"
    >
        <slot />
    </div>
</template>
